// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"249":"4327c909","541":"792d72e6","675":"75c48766","838":"792d72e6","941":"344fc770"}[chunkId] + ".chunk.css";
};